module.exports = __webpack_public_path__ + "static/media/Eats.088e1252.svg";